import io from "socket.io-client"
import angular from "angular"

angular.module("uCountitUiApp").factory("VersionSocketSrv", function ($rootScope, $window) {
  const socket = io("/version", {
    path: "/socket",
  })

  socket.on("versionInfo", (version) => {
    if ($rootScope.version && $rootScope.version !== version) {
      $window.location.reload()
      socket.disconnect()
    }
    $rootScope.version = version
  })

  return {
    socket,
  }
})
